(() => {
  if (window.__jcClarityNavigation || window.Shopify?.designMode) return;
  window.__jcClarityNavigation = true;
  const states = new WeakMap();
  const slug = (value) => value.trim().toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '').slice(0, 100) || 'unnamed';
  const label = (item) => item.querySelector(':scope > .tmenu_item_link .tmenu_item_text')?.textContent?.trim() || item.querySelector(':scope > .tmenu_item_link')?.getAttribute('title') || 'menu';
  const device = (item) => item.closest('.tmenu_app_mobile') ? 'mobile' : 'desktop';
  const send = (name) => {
    if (typeof window.clarity === 'function') window.clarity('event', name);
  };
  const scan = () => {
    document.querySelectorAll('.tmenu_app .tmenu_item_level_0.tmenu_item_has_child').forEach((item) => {
      const link = item.querySelector(':scope > .tmenu_item_link');
      const open = link?.getAttribute('aria-expanded') === 'true';
      let state = states.get(item);
      if (!state) {
        state = { open: false, selected: false };
        states.set(item, state);
      }
      if (open === state.open) return;
      const prefix = `mega_nav_${device(item)}`;
      if (open) {
        state.selected = false;
        send(`${prefix}_open`);
        send(`${prefix}_open_${slug(label(item))}`);
      } else if (!state.selected) {
        send(`${prefix}_close_without_selection`);
        send(`${prefix}_close_without_selection_${slug(label(item))}`);
      }
      state.open = open;
    });
  };
  const select = (event) => {
    if (event.type === 'auxclick' && event.button !== 1) return;
    const link = event.target instanceof Element ? event.target.closest('.tmenu_app .tmenu_item_link') : null;
    if (!link || event.target.closest('.tmenu_indicator')) return;
    const href = link.getAttribute('href')?.trim();
    if (!href || href.startsWith('#') || /^(javascript|mailto|tel):/i.test(href)) return;
    const root = link.closest('.tmenu_item_level_0');
    if (!root) return;
    if (device(root) === 'mobile' && link.parentElement.classList.contains('tmenu_item_has_child')) return;
    const state = states.get(root);
    if (state) state.selected = true;
    const prefix = `mega_nav_${device(root)}`;
    const text = link.querySelector('.tmenu_item_text')?.textContent || link.getAttribute('title') || 'link';
    send(`${prefix}_click`);
    send(`${prefix}_click_${slug(label(root))}__${slug(text)}`);
  };
  document.addEventListener('click', select, true);
  document.addEventListener('auxclick', select, true);
  new MutationObserver((records) => {
    if (records.some((record) => record.type === 'childList' || record.target.closest?.('.tmenu_app'))) scan();
  }).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-expanded'] });
  scan();
})();
